const moment = require('moment');

const REGEX_VALID_INPUT = /^(\d{0,6})$/;
const REGEX_FORMAT_REPLACE_1 = /(\d{3})/;
const REGEX_BACKSLASH_REPLACE = /\//g;
const REGEX_VALID_DATE = /^(\d{6})$/;

const REGEX_FORMAT_REPLACER = (m, s1, s2) => s2 || ( s1.slice(0, 2) + '/' + s1[2] );

export class MonthYearFormatter {

    // Example: 05032 -> false
    // Example: 052020 -> true
    // Example: 111998 -> true
    static isValidInput = (date) => {
        return date.length > 0
            ? REGEX_VALID_INPUT.test(date)
            : true;
    };

    // Example: 1 -> 1
    // Example: 12 -> 12
    // Example: 122 -> 12/2
    // Example: 1220 -> 12/20
    // Example: 12202 -> 12/202
    // Example: 122020 -> 12/2020
    static format = (date) => {
        return date
            .replace(REGEX_FORMAT_REPLACE_1, REGEX_FORMAT_REPLACER);
    };

    // Example: 1 -> 1
    // Example: 12/ -> 12
    // Example: 12/2 -> 122
    // Example: 12/20 -> 1220
    // Example: 12/202 -> 12202
    // Example: 12/2020 -> 122020
    static deformat = (date) => {
        return date
            .replace(REGEX_BACKSLASH_REPLACE, '');
    };

    // Example: 1320202 -> false
    // Example: 14a202 -> false
    // Example: .11202 -> false
    // Example: 122020 -> true
    static isValid = (date) => {
        const isSixDigits = REGEX_VALID_DATE.test(date);
        if ( !isSixDigits ) return false;
        const dateFormatted = MonthYearFormatter.format('01' + date);
        const dateMoment = moment(dateFormatted, 'DD/MM/YYYY');
        return !( dateMoment.toString() === 'Invalid date' );
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/formatters/MonthYearFormatter.js